// Item Img
import img1 from '../../../assets/img/causes/causes-1.png'
import img2 from '../../../assets/img/causes/causes-2.png'
import img3 from '../../../assets/img/causes/causes-3.png'

// Import Icon
import Icon from "../../../assets/img/icon/cal.png"
import Icon1 from "../../../assets/img/icon/user.png"




export const TrendingData = [
    {
        img: img1,
        category:"Education & integration",
        goal:"Open cohorts",
        heading: "Learning support & life in Sweden",
        para:`Homework help, language confidence, and practical guidance so children and parents navigate school and society with less stress.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img2,
        category:"Badminton",
        goal:"Year-round",
        heading: "Badminton — our main sport",
        para:`Training, ladders, and friendly tournaments for all ages. Our core activity brings the community onto court every week when halls are available.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img3,
        category:"Seasonal & social",
        goal:"Calendar",
        heading: "Swim, cricket, football & gatherings",
        para:`Seasonal blocks for swimming, cricket, and football, plus cultural festivals and social meet-ups that strengthen ties and integration.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
   
]
